import React from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import DeleteIcon from "SVGS/DeleteIcon";
import PropTypes from "prop-types";

const coverageLabels = {
  P: "Primary",
  S: "Secondary",
  T: "Tertiary",
  O: "Other",
};

const InsuranceHeader = ({
  coverageType,
  insuranceExpanded,
  onInsuranceExpandedChange,
  showRemoveButton,
  onRemovePlan,
  planIndex,
}) => {
  const handleRemoveClick = (e) => {
    e.stopPropagation();
    onRemovePlan(planIndex);
  };

  return (
    <div className="flex items-center justify-between mb-4">
      <div
        className="flex items-center justify-between flex-1 cursor-pointer"
        onClick={onInsuranceExpandedChange}
      >
        <h2 className="text-lg font-medium text-gray-900 mb-4 pb-2 flex items-center">
          {coverageLabels[coverageType] || "Insurance"} Insurance
          <span className="ml-2 text-sm text-gray-500 font-normal">
            (Optional)
          </span>
        </h2>
        <div className="flex items-center gap-2">
          {showRemoveButton && onRemovePlan && (
            <button
              type="button"
              onClick={handleRemoveClick}
              className="p-1.5 rounded text-red-500 hover:text-red-700 hover:bg-red-50 transition-colors"
              aria-label="Remove policy"
            >
              <DeleteIcon size={18} />
            </button>
          )}
          {insuranceExpanded ? (
            <FiChevronUp className="text-gray-500" />
          ) : (
            <FiChevronDown className="text-gray-500" />
          )}
        </div>
      </div>
    </div>
  );
};

InsuranceHeader.propTypes = {
  coverageType: PropTypes.string,
  insuranceExpanded: PropTypes.bool.isRequired,
  onInsuranceExpandedChange: PropTypes.func.isRequired,
  showRemoveButton: PropTypes.bool,
  onRemovePlan: PropTypes.func,
  planIndex: PropTypes.number,
};

export default InsuranceHeader;
